import React from "react";
import classNames from "classnames";
import styles from "./fix-tag.module.scss";
import { Icon } from "@/elements-react/fix-icon";

export interface FixTagProps {
  id: string;
  name: string;
  value: string;
  onRemove?: (id: string) => void;
}

export const FixTag = ({ id, name, value, onRemove }: FixTagProps) => {
  const handleRemove = () => {
    onRemove?.(id);
  };

  return (
    <span className={classNames(styles.tag)}>
      <span className={styles.parameter}>{name}:</span>
      <span className={styles.value}>{value}</span>
      {onRemove && (
        <button type="button" onClick={handleRemove} className={styles.removeButton} aria-label="Remove tag">
          <Icon name="closetag" width={12} />
        </button>
      )}
    </span>
  );
};

export default FixTag;
